import { render, staticRenderFns } from "./italic.vue?vue&type=template&id=c244f5e0&scoped=true&"
import script from "./italic.vue?vue&type=script&lang=js&"
export * from "./italic.vue?vue&type=script&lang=js&"
import style0 from "./italic.vue?vue&type=style&index=0&id=c244f5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c244f5e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
